import React, { useCallback, useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { FeedbackProvider } from './ui';

export default function AppLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = useCallback(() => setMenuOpen(false), []);

  return (
    <FeedbackProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default', color: 'text.primary' }}>
        <Sidebar open={menuOpen} onClose={closeMenu} />
        <Box sx={{ flex: '1 1 auto', minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          <Header showMenu={isMobile} menuOpen={menuOpen} onOpenMenu={() => setMenuOpen(true)} />
          <Box component="main" sx={{ flex: 1, minWidth: 0, overflowX: 'auto', px: { xs: 2, md: 3 }, py: { xs: 2, md: 3 } }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </FeedbackProvider>
  );
}
